/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocio } from '../../conexiones';
import ITiposUnidades from './entidades/tiposUnidades';

export default class ModeloTiposUnidades {
    public consultarTiposUnidades() {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() => negocio.get('TipoUnidad/ConsultarListaTipoUnidad'));
    }
    public crearTiposUnidades(tiposUnidades: ITiposUnidades) {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() =>
            negocio.post('TipoUnidad/GuardarTipoUnidad', tiposUnidades)
        );
    }
    public editarTiposUnidades(tiposUnidades: ITiposUnidades) {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() =>
            negocio.put('TipoUnidad/EditarTipoUnidad', tiposUnidades)
        );
    }
    public eliminarTiposUnidades(tiposUnidades: ITiposUnidades) {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() =>
            negocio.delete('TipoUnidad/EliminarTipoUnidad', tiposUnidades)
        );
    }

    public consultarTiposUnidadesPorFiltro(tiposUnidades: Partial<ITiposUnidades>) {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() =>
            negocio.post('TipoUnidad/ConsultarListaTipoUnidadPorFiltro', tiposUnidades)
        );
    }
}
